import { mutatorAction } from "satcheljs";
import { ScheduleCalendarType } from "sh-models";
import { SchedulesViewStateStore } from "sh-application/components/schedules/lib/store/schema/SchedulesViewStateStore";
import { IPreviewSchedulePageStore } from "../../../previewSchedulePage";

/**
 * Sets the calendar type of the Schedules page.
 */
export default mutatorAction("SET_SCHEDULE_CALENDAR_TYPE",
    function setScheduleCalendarType(
        viewState: SchedulesViewStateStore | IPreviewSchedulePageStore,
        newScheduleCalendarType: ScheduleCalendarType) {

        viewState.scheduleCalendarType = newScheduleCalendarType;
    }
);